export default __webpack_public_path__ + "static/media/SpinImg.19edbad0.png";